import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import styled from "styled-components";

// Components
import ViewPostedProReq from "../components/ViewPostedProReq";
import PodCreatedSuccessFullyCan from "../components/PodCreatedSuccessFullyCan";
import Pods from "../components/Pods";
import Podstalent from "../components/Podstalent";
import ClientPods from "../components/ClientPods";
import PartnerPods from "../components/PartnerPods";
import Notificationmanagericon from "../components/Notificationmanagericon";
import Viewpodretrotalent from "../components/Viewpodretrotalent";
import NotificationsHistorymanager from "../components/NotificationsHistorymanager";
import NotificationsHistory from "../components/NotificationsHistory";
import Createtasktalent from "../components/Createtasktalent";
import NotificationDropdown from "../components/Notificationtalent";
import ReviewsandratingPodcandidate from "../components/ReviewsandratingPodcandidate";
import Mastergithub from "../components/Mastergithub";
import CreateAgent from "../components/CreateAgent";
import ApproverDashboard from "../components/Approverdashboard";
import AgentPerformanceMetrics from "../components/Agentperformancemetrics";
import AgentsList from "../components/Agentslistintegrated";
import TalentInterviewDashboard from "../components/TalentInterviewDashboard";
import TalentMarketplace from "../components/TalentMarketplace";
import Leadpodrequests from "../components/Leadpodrequests";
import ReviewsandratingClient from "../components/ReviewsandratingClient";
import Reviewsandratingcandidate from "../components/Reviewsandratingcandidate";
import Providerprofile from "../components/podprovider/Providerprofile";
import Providerdashboard from "../components/podprovider/Providerdashboard";
import FindPodsDetails from "../components/FindPodsDetails";
import FindPodDetailsClient from "../components/FindPodDetailsClient";
import FindPods from "../components/FindPods";
import Recommendedproject from "../components/Recomendedproject";
import PartnerCreatepod from "../components/PartnerCreatepod";
import FindPodsClient from "../components/FindPodsClient";
import FindPodsPartnerGuest from "../components/FindPodsPartnerGuest";
import FindTalentPartnerGuest from "../components/FindTalentPartnerGuest";
import EditPostRequirementCand from "../components/EditPostRequirementCand";
import PodactivitytalentRetro from "../components/PodactivitytalentRetro";
import Podactivitytalent from "../components/Podactivitytalent";
import VideoViewer from "../components/VideoViewer";
import Podactivitydashboardviewall from "../components/Podactivitydashboardviewall";
import Podactivityviewalltalent from "../components/Podactivityviewalltalent";
import PostRequirementCand from "../components/PostRequirementCand";
import Createpod from "../components/Createpod";
import Updatedailystatus from "../components/Updatedailystatus";
import PodActivityLead from "../components/PodActivityLead";
import PodactivityviewalltalentEdit from "../components/PodactivityviewalltalentEdit";
import Edittalentpodactivitybyid from "../components/Edittalentpodactivitybyid";
import AddPodactivityLead from "../components/AddPodactivityLead";
import PostRequirementPod from "../components/PostRequirementPod";
import PostRequirementdata from "../components/ProjectRequirementdata";
import GlobalLens from "../components/GlobalLens";
import PostRequirement from "../components/PostRequirement";
import CreateSolution from "../components/CreateSolution";
import Teammembers from "../components/Teammembers";
import { ManagerTicketView, TalentTicketSearch, CreateTicketButton } from "../components/CreateTicketManager";
import Browsetalents from "../components/Browsetalents";
import GlobalRollouts from "../components/GlobalRollouts";
import GlobalVOC from "../components/GlobalVOC";
import AIAgentSearch from "../components/AIAgentSearch";
import Browsetalentspartner from "../components/Browsetalentspartner";
import SubscriptionNew from "../components/SubscriptionNew";
import ChangePassword from "../components/auth/ChangePassword";
import ChangePasswordConfirm from "../components/auth/ChangePasswordConfirm";
import Clientprofile from "../components/Clientprofile";
import Partnerguest from "../components/Partnerguest";
import Stakeholder from "../components/Stakeholder";
import CustomerProfile from "../components/CustomerProfile";
import Sonarprojectdetailsmetrics from "../components/Sonarprojectdetailsmetrics";
import AiSprintRetro from "../components/AiSprintRetro";
import PodMetricsTalentDetailview from "../components/PodMetricsTalentDetailview";
import PopupDefectsdetailviewchart from "../components/PopupDefectsdetailviewchart";
import PopupDetailviewmetrics from "../components/PopupDetailviewmetrics";
import CicdPopup from "../components/CicdPopup";
import TimeDetailView from "../components/TimeDetailView";
import CloudCost from "../components/CloudCost";
import ProjectPieChart from "../components/ProjectPieChart";
import CicdPiechartmanagerdetailvivew from "../components/CicdPiechartmanagerdetailvivew";
import OpenAi from "../components/OpenAi";
import PodAutomation from "../components/PodAutomation";
import PodMetricsmanager from "../components/PodMetricsmanager";
import Podretromanager from "../components/Podretromanager";
import DetailPRcountmanager from "../components/DetailPRcountmanager";
import Githublinesofcodebydaywise from "../components/Githublinesofcodebydaywise";
import Portfolio from "../components/Portfolio";
import KanbanboardTalent from "../components/KanbanboardTalent";
import PRCountTalent from "../components/PRCountTalent";
import ProfileVisibilityMUI from "../ProfileSettings";
import InvoicesClient from "../components/InvoicesClient";
import DetailviewGithublinesofcode from "../components/DetailviewGithublinesofcode";
import Githublinespiecharttalent from "../components/Githublinespiecharttalent";
import Defectsdetailviewchart from "../components/Defectsdetailviewchart";
import Detailsviewmetrics from "../components/Detailsviewmetrics";
import KanbanBoard from "../components/KanbanBoard";
import Stakeholderinvite from "../components/Stakeholderinvite";
import MeetingSummariesTableTalent from "../components/MeetingSummariesTableTalent";
import MeetingSummariesTimeline from "../components/MeetingSummariesTimeline";
import PodActivitystakeholderviewall from "../components/PodActivitystakeholderviewall";
import PodActivityStakeholder from "../components/PodActivityStakeholder";
import Setting from "../components/Setting";
import EditTalentSettingsForm from "../components/EditTalentSettingsForm";
import Clientinvite from "../components/Clientinvite";
import TaskForm from "../components/TaskForm";
import StakeholderLayout from "../components/StakeholderLayout";
import ProfileSuccessScreen from "../components/ProfileSuccessScreen";
import Mypod from "../components/Mypod";
import PodActivity from "../components/PodActivity";
import Podprovidermypod from "../components/Podprovidermypod";
import Candidatedetailsbyid from "../components/Candidatedetailsbyid";
import Poddetaillscandidate from "../components/Poddetaillscandidate";
import Clientcreatepod from "../components/Clientcreatepod";
import CandidateSearch from "../components/CandidateSearch";
import EmployerProjectReq from "../components/EmployerProjectReq";
import Employeepf from "../components/Employeepf";
import SearchProjects from "../components/SearchProjects";
import CandidateAdminDashboard from "../components/CandidateAdminDashboard";
import Master from "../components/Master";
import Popupstakeholdermanager from "../components/Popupstakeholdermanager";
import TimeSubmit from "../components/TimeSubmit";
import PodInsights from "../components/PodInsights";
import Popup from "../components/Popup";
import ClientAdminDashboard from "../components/ClientAdminDashboard";
import PartnerAdminDashboard from "../components/PartnerAdminDashboard";
import Candidateapprove from "../components/Candidateapprove";
import Patnerdetailsapprove from "../components/Patnerdetailsapprove";
import Leadpodrequestdetails from "../components/Leadpodrequestdetails";
import Clientcreatepodinvite from "../components/Clientcreatepodinvite";
import BarGraph from "../components/BarGraph";
import PRcountgraph from "../components/PRcountgraph";
import BarGraphstories from "../components/BarGraphstories";
import SprintVelocityChart from "../components/SprintVelocityChart ";
import Clientadminprofile from "../components/Clientadminprofile";
import PartnerManagePod from "../components/PartnerManagePod";
import ManagePod from "../components/ManagePod";
import ControlPlaneLayout from "../components/controlplane/ControlPlaneLayout";
import ClientManagePod from "../components/ClientManagePod";
import Updateprofile from "../components/Updateprofile";
import Updateyourprofile from "../components/Updateyourprofile";
import ViewPodTasksManagerbyid from "../components/ViewPodTasksManagerbyid";
import ViewPodTasksManager from "../components/ViewPodTasksManager";
import PodProductivity from "../components/PodProductivity";
import ControlPlaneDashboard from "../components/controlplane/ControlPlaneDashboard";
import Header from "../components/Header";

const PodRoutes = (props) => {
    const isUserAuthenticated = props.isUserAuthenticated;
    const user = props.user;
    const authProps = props.authProps;
    const collapsed = props.collapsed;
    const expanded = props.expanded;
    const isLoggedIn = props.isLoggedIn;
    const currentLocale = props.currentLocale;
    const changeLocale = props.changeLocale;
    return (
        <>
            <Route
                exact
                path="/ViewPostedProReq"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ViewPostedProReq />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PodCreatedSuccessFullyCan"
                render={(props) => (
                    <PodCreatedSuccessFullyCan {...props} auth={authProps} />
                )}
            />
            <Route
                exact
                path="/Pods"
                render={(props) => {
                    if (isUserAuthenticated()) {
                        const userType = user.data[0].type;
                        if (
                            userType === "Candidate" &&
                            user.data[0].isPodLeader === "true"
                        ) {
                            return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                                <Pods />
                            </ControlPlaneLayout>;
                        } else if (userType === "Candidate") {
                            return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                                <Podstalent />
                            </ControlPlaneLayout>;
                        } else if (userType === "Client") {
                            return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                                <ClientPods />
                            </ControlPlaneLayout>;
                        } else if (userType === "Provider") {
                            return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                                <PartnerPods />
                            </ControlPlaneLayout>;
                        }
                    }
                    return (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Notificationmanagericon"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Notificationmanagericon />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Viewpodretrotalent"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Viewpodretrotalent />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/NotificationsHistorymanager"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <NotificationsHistorymanager />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/NotificationsHistory"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <NotificationsHistory />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Createtasktalent"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Createtasktalent collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/NotificationDropdown"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <NotificationDropdown />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/ReviewsandratingPodcandidate"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <ReviewsandratingPodcandidate />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Mastergithub"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Mastergithub collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/CreateAgent"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <CreateAgent collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/ApproverDashboard"
                render={(props) => {
                    const isAuth = isUserAuthenticated();
                    const userType = user?.data?.[0]?.type;
                    if (isAuth && userType === "Candidate") {
                        return (
                            <ControlPlaneLayout collapsed={collapsed} currentLocale={currentLocale} changeLocale={changeLocale}>
                                <ApproverDashboard collapsed={collapsed} />
                            </ControlPlaneLayout>
                        );
                    }
                    return <Redirect to="/login" />;
                }}
            />
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                pauseOnHover
            />
            <Route
                exact
                path="/AgentsList"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <AgentsList collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/AgentPerformanceMetrics"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <AgentPerformanceMetrics collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/TalentInterviewDashboard"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <TalentInterviewDashboard collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/TalentMarketplace"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <TalentMarketplace collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />

            <Route
                exact
                path="/Leadpodrequests"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <Leadpodrequests />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/ReviewsandratingClient"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <ReviewsandratingClient />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Reviewsandratingcandidate"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Reviewsandratingcandidate />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/provider-profile"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Provider" ? (
                        <Providerprofile />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/provider-dashboard"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Provider" ? (
                        <Providerdashboard />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/FindPodsDetails"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <FindPodsDetails collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/FindPodDetailsClient/:id"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <FindPodDetailsClient {...props} auth={authProps} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/FindPods"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <FindPods collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/recommendedproject"
                render={(props) => (
                    <Recommendedproject {...props} auth={authProps} />
                )}
            />
            <Route
                exact
                path="/PartnerCreatepod"
                render={(props) => <PartnerCreatepod {...props} auth={authProps} />}
            />
            <Route
                exact
                path="/FindPodsClient"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <FindPodsClient
                                {...props}
                                auth={authProps}
                                collapsed={collapsed}
                            />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/FindPodsPartnerGuest"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "PartnerGuest" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <FindPodsPartnerGuest {...props} auth={authProps} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/FindTalentPartnerGuest"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "PartnerGuest" ? (
                        <FindTalentPartnerGuest {...props} auth={authProps} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/EditPostRequirementCand/:id"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <EditPostRequirementCand />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PodactivitytalentRetro"
                render={(props) => {
                    if (!isUserAuthenticated()) {
                        return <Redirect to={{ pathname: "/login" }} />;
                    }
                    if (user.data[0].type !== "Candidate") {
                        return <Redirect to={{ pathname: "/login" }} />;
                    }
                    return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                        <PodactivitytalentRetro collapsed={collapsed} />
                    </ControlPlaneLayout>;
                }}
            />
            <Route
                exact
                path="/Podactivitytalent"
                render={(props) => {
                    if (!isUserAuthenticated()) {
                        return <Redirect to={{ pathname: "/login" }} />;
                    }
                    if (user.data[0].type !== "Candidate") {
                        return <Redirect to={{ pathname: "/login" }} />;
                    }
                    return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                        <Podactivitytalent collapsed={collapsed} />
                    </ControlPlaneLayout>;
                }}
            />
            <Route
                exact
                path="/video-viewer/:state"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <VideoViewer {...props} />
                    ) : (
                        <Redirect to={{ pathname: "/login" }} />
                    );
                }}
            />
            <Route
                exact
                path="/Podactivitydashboardviewall"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <Podactivitydashboardviewall />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Podactivityviewalltalent"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <Podactivityviewalltalent />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PostRequirementCand"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        user.data[0].isPodLeader === "true" ? (
                            <PostRequirementCand />
                        ) : (
                            (
                                <>
                                    {window.alert("Your are not pod leader to post a requirement")}
                                    {(window.location.href = "/Pods")}
                                </>
                            )
                        )
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/create-pod"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        user.data[0].isPodLeader === "true" ? (
                            <Createpod />
                        ) : (
                            (
                                <>
                                    {window.alert("Your are not pod leader to create pod")}
                                    {(window.location.href = "/candidate-dashboard")}
                                </>
                            )
                        )
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Updatedailystatus"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        user.data[0].isPodLeader === "true" ? (
                            <Updatedailystatus />
                        ) : (
                            <></>
                        )
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PodActivityLead"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        user.data[0].isPodLeader === "true" ? (
                            <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                                <PodActivityLead />
                            </ControlPlaneLayout>
                        ) : (
                            <></>
                        )
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PodactivityviewalltalentEdit/:id"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <PodactivityviewalltalentEdit />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Edittalentpodactivitybyid"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <Edittalentpodactivitybyid />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/AddPodactivityLead/:pod_id"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        user.data[0].isPodLeader === "true" ? (
                            <AddPodactivityLead />
                        ) : (
                            <>{(window.location.href = "/Podactivitytalent/:pod_id")}</>
                        )
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PostRequirementPod"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <PostRequirementPod {...props} auth={authProps} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PostRequirementdata"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <PostRequirementdata {...props} auth={authProps} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/GlobalLens"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <GlobalLens {...props} auth={authProps} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/project-requirment"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PostRequirement {...props} auth={authProps} collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/CreateSolution"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <CreateSolution {...props} auth={authProps} collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Team"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Teammembers
                                {...props}
                                auth={authProps}
                                collapsed={collapsed}
                            />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/ManagerTicketView"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ManagerTicketView
                            {...props}
                            auth={authProps}
                            collapsed={collapsed}
                        />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/TalentTicketSearch"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <TalentTicketSearch
                            {...props}
                            auth={authProps}
                            collapsed={collapsed}
                        />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/CreateTicketButton"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <CreateTicketButton
                            {...props}
                            auth={authProps}
                            collapsed={collapsed}
                        />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/browse-talent"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <Browsetalents
                            {...props}
                            auth={authProps}
                            collapsed={collapsed}
                        />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/GlobalRollouts"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <GlobalRollouts
                            {...props}
                            auth={authProps}
                            collapsed={collapsed}
                        />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/GlobalVOC"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <GlobalVOC
                            {...props}
                            auth={authProps}
                            collapsed={collapsed}
                        />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/AIAgentSearch"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <AIAgentSearch
                            {...props}
                            auth={authProps}
                            collapsed={collapsed}
                        />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/browse-talent-partner"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Provider" ? (
                        <Browsetalentspartner {...props} auth={authProps} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/subscriptions"
                render={(props) => {
                    const isClientAdmin = isUserAuthenticated() && (user.data[0].type === "ClientAdmin" || user.data[0].type === "customer");
                    
                    if (isClientAdmin) {
                        return (
                            <div className="artemy-root" style={{ background: '#08090d', minHeight: '100vh' }}>
                                <Header currentLocale={currentLocale} changeLocale={changeLocale} />
                                <SubscriptionNew />
                            </div>
                        );
                    }

                    return isUserAuthenticated() ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <SubscriptionNew />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/changepassword"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <ChangePassword />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/changepasswordconfirmation"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <ChangePasswordConfirm />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/client-profile"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Clientprofile
                                changeLocale={changeLocale}
                                currentLocale={currentLocale}
                                collapsed={collapsed}
                            />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/partnerguest-profile"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "PartnerGuest" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Partnerguest
                                changeLocale={changeLocale}
                                currentLocale={currentLocale}
                            />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />

            <Route
                exact
                path="/PRCountTalent"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PRCountTalent />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/ProfileVisibilityMUI"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <ProfileVisibilityMUI />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/InvoicesClient"
                render={(props) => {
                    const isClientAdmin = isUserAuthenticated() && (user.data[0].type === "ClientAdmin" || user.data[0].type === "customer");
                    if (isClientAdmin) {
                        return (
                            <div className="artemy-root" style={{ background: '#08090d', minHeight: '100vh' }}>
                                <Header currentLocale={currentLocale} changeLocale={changeLocale} />
                                <InvoicesClient />
                            </div>
                        );
                    }
                    return isUserAuthenticated() && user.data[0].type === "ClientAdmin" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <InvoicesClient />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/DetailviewGithublinesofcode"
                render={(props) => {
                    return isUserAuthenticated() &&
                        user.data[0].type === "Client" &&
                        "stakeholder" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <DetailviewGithublinesofcode />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Githublinespiecharttalent"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Githublinespiecharttalent />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Defectsdetailviewchart"
                render={(props) => {
                    return isUserAuthenticated() &&
                        user.data[0].type === "Client" &&
                        "Candidate" &&
                        "stakeholder" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Defectsdetailviewchart />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Detailsviewmetrics"
                render={(props) => {
                    return isUserAuthenticated() &&
                        user.data[0].type === "Client" &&
                        "stakeholder" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Detailsviewmetrics />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/KanbanBoard"
                render={(props) => {
                    if (!isUserAuthenticated() || user.data[0].type !== "Client") {
                        return <Redirect to={{ pathname: "/login" }} />;
                    }
                    return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                        <KanbanBoard collapsed={collapsed} />
                    </ControlPlaneLayout>;
                }}
            />
            <Route
                exact
                path="/Stakeholderinvite"
                render={(props) => {
                    const isClientAdmin = isUserAuthenticated() && (user.data[0].type === "ClientAdmin" || user.data[0].type === "customer");
                    if (isClientAdmin) {
                        return (
                            <div className="artemy-root" style={{ background: '#08090d', minHeight: '100vh' }}>
                                <Header currentLocale={currentLocale} changeLocale={changeLocale} />
                                <Stakeholderinvite />
                            </div>
                        );
                    }
                    return isUserAuthenticated() && user.data[0].type === "ClientAdmin" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Stakeholderinvite />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/MeetingSummariesTableTalent"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <MeetingSummariesTableTalent
                                collapsed={collapsed}
                                expanded={expanded}
                            />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/MeetingSummariesTimeline"
                render={(props) => {
                    return isUserAuthenticated() &&
                        (user.data[0].type === "Client" ||
                            user.data[0].type === "Candidate") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <MeetingSummariesTimeline
                                collapsed={collapsed}
                                expanded={expanded}
                            />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/KanbanboardTalent"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <KanbanboardTalent collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PodMetricsTalentDetailview"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PodMetricsTalentDetailview collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/OpenAi"
                render={(props) => {
                    return isUserAuthenticated() && (user.data[0].type === "Client" || user.data[0].type === "Candidate" || user.data[0].type === "stakeholder") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <OpenAi collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PodActivitystakeholderviewall"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "stakeholder" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PodActivitystakeholderviewall
                                currentLocale={currentLocale}
                                changeLocale={changeLocale}
                                collapsed={collapsed}
                                expanded={expanded}
                            />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PodActivityStakeholder"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "stakeholder" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PodActivityStakeholder />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Setting"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Setting collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/EditTalentSettingsForm"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <EditTalentSettingsForm collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Clientinvite"
                render={(props) => {
                    const isClientAdmin = isUserAuthenticated() && (user.data[0].type === "ClientAdmin" || user.data[0].type === "customer");
                    if (isClientAdmin) {
                        return (
                            <div className="artemy-root" style={{ background: '#08090d', minHeight: '100vh' }}>
                                <Header currentLocale={currentLocale} changeLocale={changeLocale} />
                                <Clientinvite />
                            </div>
                        );
                    }
                    return isUserAuthenticated() && user.data[0].type === "ClientAdmin" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Clientinvite />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/TaskForm"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <TaskForm collapsed={collapsed} expanded={expanded} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/StakeholderDashboard"
                render={(props) => {
                    const shouldRenderDashboard =
                        isUserAuthenticated() &&
                        user.data[0].type === "stakeholder" &&
                        user.data[0].isApproved === "Approved";
                    
                    if (shouldRenderDashboard) {
                        return (
                            <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                                <ControlPlaneDashboard />
                            </ControlPlaneLayout>
                        );
                    }
                    
                    if (isUserAuthenticated() && user.data[0].type === "stakeholder") {
                         return (
                            <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                                <ProfileSuccessScreen />
                            </ControlPlaneLayout>
                        );
                    }

                    return <Redirect to={{ pathname: "/login" }} />;
                }}
            />
            <Route
                exact
                path="/mypod"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Mypod {...props} auth={authProps} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PodActivity"
                render={(props) => {
                    if (!isUserAuthenticated()) {
                        return <Redirect to={{ pathname: "/login" }} />;
                    }
                    if (user.data[0].type !== "Client") {
                        return <Redirect to={{ pathname: "/login" }} />;
                    }
                    return (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PodActivity
                                {...props}
                                auth={authProps}
                                collapsed={collapsed}
                                expanded={expanded}
                            />
                        </ControlPlaneLayout>
                    );
                }}
            />
            <Route
                exact
                path="/Podproviderpodactivity"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Provider" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Podprovidermypod {...props} auth={authProps} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Candidatedetailsbyid"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Candidatedetailsbyid />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/poddetail"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Poddetaillscandidate />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/client-createpod"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Clientcreatepod />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/candidatesearch"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <CandidateSearch />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/employeeprojectreq"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <EmployerProjectReq />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/employeepf"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Employeepf />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/searchprojects"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <SearchProjects />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/candidateadmin-dashboard"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "CandidateAdmin" ? (
                        <CandidateAdminDashboard />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/admin-login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Master"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <Master />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Popupstakeholdermanager"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Popupstakeholdermanager />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/TimeSubmit"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <TimeSubmit />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PodInsights"
                render={(props) => {
                    if (!isLoggedIn) {
                        return <Redirect to={{ pathname: "/login" }} />;
                    }
                    if (user.data[0].type === "Client") {
                        return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PodInsights collapsed={collapsed} />
                        </ControlPlaneLayout>;
                    } else {
                        return <Redirect to="/" />;
                    }
                }}
            />
            <Route
                exact
                path="/Popup"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Popup />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/clientadmin-dashboard"
                render={(props) => {
                    const isClientAdmin = isUserAuthenticated() && (user.data[0].type === "ClientAdmin" || user.data[0].type === "customer");
                    if (isClientAdmin) {
                        return (
                            <div className="artemy-root" style={{ background: '#08090d', minHeight: '100vh' }}>
                                <Header currentLocale={currentLocale} changeLocale={changeLocale} />
                                <ClientAdminDashboard />
                            </div>
                        );
                    }
                    return isUserAuthenticated() && (user.data[0].type === "ClientAdmin" || user.data[0].type === "customer") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <ClientAdminDashboard />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PartnerAdminDashboard"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "ProviderAdmin" ? (
                        <PartnerAdminDashboard />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/admin-login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/candidate-profile/:id"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "CandidateAdmin" ? (
                        <Candidateapprove />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/admin-login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Patnerdetailsapprove/:id"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "ProviderAdmin" ? (
                        <Patnerdetailsapprove />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/admin-login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Leadpodrequestdetails"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Leadpodrequestdetails />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Clientcreatepodinvite"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Clientcreatepodinvite />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/BarGraph"
                render={(props) => {
                    return isUserAuthenticated() &&
                        (user.data[0].type === "Client" ||
                        user.data[0].type === "stakeholder") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <BarGraph />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/PRcountgraph"
                render={(props) => {
                    return isUserAuthenticated() &&
                        (user.data[0].type === "Client" ||
                        user.data[0].type === "stakeholder") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PRcountgraph />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/BarGraphstories"
                render={(props) => {
                    return isUserAuthenticated() &&
                        (user.data[0].type === "Client" ||
                        user.data[0].type === "stakeholder") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <BarGraphstories />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/SprintVelocityChart"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <SprintVelocityChart />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/clientadmin-profile/:id"
                render={(props) => {
                    return isUserAuthenticated() && (user.data[0].type === "ClientAdmin" || user.data[0].type === "customer") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Clientadminprofile />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/admin-login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/ManagePod"
                render={(props) => {
                    if (isUserAuthenticated()) {
                        const userType = user.data[0].type;
                        if (userType === "Provider") {
                            return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                                <PartnerManagePod />
                            </ControlPlaneLayout>;
                        } else if (userType === "Candidate") {
                            return <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                                <ManagePod />
                            </ControlPlaneLayout>;
                        }
                    }
                    return (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/ClientManagePod"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <ClientManagePod collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/Podretromanager"
                render={(props) => {
                    return isUserAuthenticated() && (user.data[0].type === "Client" || user.data[0].type === "stakeholder") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Podretromanager collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect to={{ pathname: "/login" }} />
                    );
                }}
            />
            <Route
                exact
                path="/PodMetricsmanager"
                render={(props) => {
                    return isUserAuthenticated() && (user.data[0].type === "Client" || user.data[0].type === "stakeholder") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PodMetricsmanager collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect to={{ pathname: "/login" }} />
                    );
                }}
            />
            <Route
                exact
                path="/ViewPodTasksManagerbyid"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <ViewPodTasksManagerbyid collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect to={{ pathname: "/login" }} />
                    );
                }}
            />
            <Route
                exact
                path="/ViewPodTasksManager"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <ViewPodTasksManager collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect to={{ pathname: "/login" }} />
                    );
                }}
            />
            <Route
                exact
                path="/PodProductivity"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PodProductivity collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect to={{ pathname: "/login" }} />
                    );
                }}
            />
            <Route
                exact
                path="/PodAutomation"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Client" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <PodAutomation collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect to={{ pathname: "/login" }} />
                    );
                }}
            />
            <Route
                exact
                path="/Updateyourprofile"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "Candidate" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Updateyourprofile collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/profilesuccesss"
                render={(props) => {
                    return isUserAuthenticated() ? (
                        <ProfileSuccessScreen />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                            }}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/customer-profile"
                render={(props) => {
                    const isClientAdmin = isUserAuthenticated() && (user.data[0].type === "ClientAdmin" || user.data[0].type === "customer");
                    if (isClientAdmin) {
                        return (
                            <div className="artemy-root" style={{ background: '#08090d', minHeight: '100vh' }}>
                                <Header currentLocale={currentLocale} changeLocale={changeLocale} />
                                <CustomerProfile currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed} />
                            </div>
                        );
                    }
                    return isUserAuthenticated() && (user.data[0].type === "ClientAdmin" || user.data[0].type === "customer") ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <CustomerProfile currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect to={{ pathname: "/login" }} />
                    );
                }}
            />
            <Route
                exact
                path="/stakeholder-profile"
                render={(props) => {
                    return isUserAuthenticated() && user.data[0].type === "stakeholder" ? (
                        <ControlPlaneLayout currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed}>
                            <Stakeholder currentLocale={currentLocale} changeLocale={changeLocale} collapsed={collapsed} />
                        </ControlPlaneLayout>
                    ) : (
                        <Redirect to={{ pathname: "/login" }} />
                    );
                }}
            />
        </>
    );
};

export default PodRoutes;
